import { useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useDrawer = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [elementId, setElementId] = useState(null);
    const [type, setType] = useState('');
    const [section, setSection] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    const openDrawer = useCallback(
        (id, type, sectionName = '') => {
            setElementId(id);
            setType(type);
            setIsDrawerOpen(true);
            setSection(sectionName);
            const sectionParam = sectionName ? `&section=${sectionName}` : '';
            navigate({
                pathname: location.pathname,
                search: location.search,
                hash: `#${id}?${type}${sectionParam}`,
            });
        },
        [navigate, location.pathname, location.search],
    );

    const closeDrawer = useCallback(() => {
        setElementId(null);
        setIsDrawerOpen(false);
        navigate(-1);
        setType(null);
        setSection('');
    }, [navigate]);

    const closeAllDrawers = useCallback(() => {
        setElementId(null);
        setIsDrawerOpen(false);
        setType(null);
        setSection('');
        navigate({ pathname: location.pathname, search: location.search }, { replace: true });
    }, [navigate, location.pathname, location.search]);

    useEffect(() => {
        const match = location.hash.match(/#([^?]+)/);
        const hashId = match ? match[1] : null;
        const typeUrl = location.hash.split('?')[1];
        if (hashId) {
            setElementId(hashId);
            setIsDrawerOpen(true);
            if (typeUrl) {
                const [typeValue, ...params] = typeUrl.split('&');
                setType(typeValue);
                const sectionParam = params.find(param => param.startsWith('section='));
                setSection(sectionParam ? sectionParam.replace('section=', '') : '');
            }
        } else {
            setElementId(null);
            setIsDrawerOpen(false);
            setType(null);
            setSection('');
        }
    }, [location.hash]);

    return {
        isDrawerOpen,
        elementId,
        type,
        section,
        openDrawer,
        closeDrawer,
        closeAllDrawers,
    };
};
